import { Box, CssBaseline, CssVarsProvider } from '@mui/joy';
import React, { useContext } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../helper/AuthProvider';

type Props = {};

const Layout = (props: Props) => {
  const { checkAuth } = useContext(AuthContext);
  return checkAuth() ? (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
        <Header />
        <Sidebar />
        <Box
          component='main'
          className='MainContent'
          sx={{
            overflowY: 'auto',
            px: { xs: 2, md: 6 },
            pt: {
              xs: 'calc(12px + var(--Header-height))',
              sm: 'calc(12px + var(--Header-height))',
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            height: '100dvh',
            gap: 1,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </CssVarsProvider>
  ) : (
    <Navigate to='/login' replace />
  );
};

export default Layout;
